import { AuthService } from '../../../../services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackbarService } from '../../../../services/snackbar/snackbar.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-confirmar-codigo',
  imports: [
    MatButtonModule,
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './confirmar-codigo.html',
  styleUrls: ['./confirmar-codigo.scss'],
})
export class ConfirmarCodigo implements OnInit {
  email: string = '';
  digits = Array(6).fill(0);
  codigo: string[] = [];
  isLoading = false;

  // Timer
  timerSeconds = 0;
  timerInterval?: any;
  podeReenviar = true;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly snackbarService: SnackbarService
  ) {
  }

  async ngOnInit() {
    this.email =
      this.route.snapshot.queryParamMap.get('email') ??
      sessionStorage.getItem('recovery_email') ??
      '';

    const codigoFromParams = this.route.snapshot.queryParamMap.get('codigo');
    if (codigoFromParams && codigoFromParams.length === 6) {
      this.codigo = codigoFromParams.split('');
      await this.confirmarCodigo();
    } else {
      this.codigo = Array(6).fill('');
    }

    this.iniciarTimer(60);
  }

  onInput(event: Event, index: number) {
    // seu código já funciona bem
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, '');
    if (!value) {
      this.codigo[index] = '';
      return;
    }
    this.codigo[index] = value.charAt(0);
    input.value = this.codigo[index];

    if (index < 5 && value) {
      const nextInput = input.parentElement?.children[
        index + 1
      ] as HTMLInputElement;
      nextInput?.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = input.parentElement?.children[
        index - 1
      ] as HTMLInputElement;
      prevInput?.focus();
    }
  }

  async confirmarCodigo() {
    if (this.codigo.some((d) => !d)) return;
    const codigoCompleto = this.codigo.join('');

    this.isLoading = true;
    try {
      await this.authService.confirmarCodigo(this.email, codigoCompleto);
      this.isLoading = false;
      this.snackbarService.success('Código confirmado!');
      this.router.navigate(['/auth/definir-senha']);
    } catch (err: any) {
      this.snackbarService.error(err.response.data.error ?? err.message);
    }

    this.isLoading = false;
  }

  async reenviarCodigo(event: Event) {
    event.preventDefault();

    if (!this.podeReenviar) {
      return;
    }

    this.isLoading = true;
    try {
      await this.authService.solicitarCodigo(this.email);
      this.isLoading = false;
      this.snackbarService.success(
        `Novo código de verificação enviado para o seu e-mail!`
      );
      this.iniciarTimer(60);
    } catch (err: any) {
      this.snackbarService.success(
        `Ocorreu um erro ao enviar o código para o seu e-mail. Por favor, tente novamente mais tarde.`
      );

      this.isLoading = false;
      this.router.navigate(['/auth/recuperar-senha']);
    }
    this.isLoading = false;
  }

  iniciarTimer(segundos: number) {
    this.timerSeconds = segundos;
    this.podeReenviar = false;

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      this.timerSeconds--;

      if (this.timerSeconds <= 0) {
        clearInterval(this.timerInterval);
        this.podeReenviar = true;
      }
    }, 1000);
  }

  voltarParaLogin() {
    this.router.navigate(['/auth/login']);
  }
}
